import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=1bbdd70f&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"
import style0 from "./Foot.vue?vue&type=style&index=0&id=1bbdd70f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdd70f",
  null
  
)

export default component.exports